<template>
  <div class="deceit_share">
    <div class="logo_image"></div>
    <div class="info">
      <p class="user_image">
        <img :src="avatar" alt />
      </p>
      <div class="user_info">
        <p class="name">{{username}}</p>
        <p class="room_num">房间号：{{spyRoomId}}</p>
      </div>
    </div>
    <div class="bg_image">
      <img src="../../assets/images/deceitimages/v1/tupian@2x.png" />
    </div>
    <p class="invite_info">邀请您来玩</p>
    <div class="btn_image">
      <div class="btn_motial" @click="share"></div>
      <img src="../../assets/images/deceitimages/v1/button@2x.png" alt />
    </div>
      <!-- 引入模态组件 -->
     <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.'+ '点击右上角[...]'"
      :direct="'2. '+'选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
      :num="'房间号:'+spyRoomId"
    ></Appopen>
  </div>
</template>
<script>
import axios from "axios";
import { appUrlAndroid, appUrlIOS } from "../../assets/js/base64";
export default {
  data() {
    return {
      avatar:'',
      username:'',
      spyRoomId:'',
      isAppopen:false
    };
  },
   components:{
     Appopen: () => import("../../component/Appopen.vue")
  },
  created() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    document.getElementsByTagName("title")[0].innerText = "谁是卧底";
    this.userId = this.$route.query.id; 
    this.room = this.$route.query.num;
    this.getShareInfo();
  },
  methods: {
    share() {
      this.baseUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan";
      if (this.isAndroid) {
        window.location.href =
          this.baseUrl + `&android_schema=${appUrlAndroid("250000","roomId="+this.spyRoomId)}`;
      } else if (this.isiOS) {
        let ua = navigator.userAgent.toLowerCase();
           if(ua.match(/QQ/i) == "qq"){
             this.isAppopen = true
           }else{
             //添加跳转游戏房间号 参数即成功
              window.location.href = appUrlIOS('250000',"roomId="+this.spyRoomId);
           }
      }else{
             window.location.href = 'http://share.xiyacs.com/#/open'
      }
    },
    getShareInfo() {
      axios
        .post(this.$interfaces.getDeceitInfo, { userId: this.userId })
        .then(res => {
          let data = res.data.data ;
          // console.log(data)
          this.avatar = data.user.avatar;
          this.username = data.user.nickname;
          this.spyRoomId = data.spyRoomId ? data.spyRoomId : this.room;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted(){}
};
</script>
<style scoped>
.deceit_share {
  width: 100vw;
  height: 100vh;
  padding-top: 1.075rem;
  position: relative;
}
.deceit_share .logo_image {
  background: url("../../assets/images/deceitimages/v1/logo@2x.png") no-repeat;
  background-size: cover;
  width: 3.55rem;
  height: 0.925rem;
  margin-left: 0.6rem;
  margin-bottom: 1.825rem;
}
.deceit_share .info {
  display: flex;
  justify-content: flex-start;
}
.deceit_share .info .user_image {
  width: 2.85rem;
  height: 2.85rem;
  margin-left: 0.6rem;
  border-radius: 50%;
  overflow: hidden;
}
.deceit_share .info .user_image img {
  width: 100%;
  height: 100%;
}
.deceit_share .info .user_info {
  flex: 1;
  margin-left: 0.6rem;
  text-align: left;
}
.deceit_share .info .user_info .name {
  font-size: 0.9rem;
  font-family: "PingFang SC";
  font-weight: 800;
  color: rgba(68, 68, 68, 1);
  line-height: 0.95rem;
  padding-top: 0.25rem;
}
.deceit_share .info .user_info .room_num {
  width: 4.5rem;
  height: 1.15rem;
  background: rgba(251, 173, 47, 1);
  border-radius: 0.15rem;
  margin-top: 0.4rem;
  font-size: 0.6rem;
  font-family: "PingFang SC";
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 1.15rem;
  text-align: center;
}
.deceit_share .bg_image {
  width: 100vw;
  height: 13.5rem;
  margin-top: 0.2rem;
  margin-bottom: 7.125rem;
}
.deceit_share .bg_image img {
  width: 100%;
  height: 100%;
}
.deceit_share .invite_info {
  font-size: 0.7rem;
  font-family: "PingFang SC";
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  line-height: 0.95rem;
}
.deceit_share .btn_image {
  width: 100vw;
  height: 3.775rem;
  position: relative;
}
.deceit_share .btn_image img {
  width: 100%;
  height: 100%;
}
.deceit_share .btn_image .btn_motial {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 3.775rem;
  background: rgba(0, 0, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/components/deceit/deceit_share.vue